{
  "name": "fit-pro-tracker",
  "version": "0.0.1",
  "author": "Fit Pro Tracker",
  "homepage": "https://fitprotracker.com/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --configuration=dev --port=4200",
    "build": "ng build",
    "build:dev": "ng build --configuration=dev",
    "deploy:android": "ng build && npx cap sync android && cd android && gradlew.bat assembleDebug && adb install -r app\\build\\outputs\\apk\\debug\\app-debug.apk",
    "test": "ng test",
    "lint": "ng lint",
    "postinstall": "jetifier",
    "cap-config": "cap-config",
    "pwa:assets": "node scripts/generate-pwa-assets.js",
    "client:generate": "node scripts/generate-client.js",
    "client:check": "node scripts/check-client.js",
    "client:list": "node scripts/switch-client.js --list",
    "client:switch": "node scripts/switch-client.js",
    "client:reset": "node scripts/switch-client.js --reset",
    "client:build": "npm run build:dev && npx cap sync && cd android && .\\gradlew assembleDebug",
    "client:deploy": "npm run client:build && adb install -r android\\app\\build\\outputs\\apk\\debug\\app-debug.apk"
  },
  "playwright": {
    "testDir": "e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.4",
    "@angular/cdk": "^20.2.8",
    "@angular/common": "^20.3.4",
    "@angular/compiler": "^20.3.4",
    "@angular/core": "^20.3.4",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.3.4",
    "@angular/localize": "^20.3.4",
    "@angular/platform-browser": "^20.3.4",
    "@angular/platform-browser-dynamic": "^20.3.4",
    "@angular/router": "^20.3.4",
    "@angular/service-worker": "^20.3.4",
    "@aparajita/capacitor-biometric-auth": "^9.0.0",
    "@aspnet/signalr": "^1.0.27",
    "@auth0/angular-jwt": "^5.0.2",
    "@awesome-cordova-plugins/file-opener": "^6.7.0",
    "@capacitor/android": "^7.4.5",
    "@capacitor/app": "^7.0.0",
    "@capacitor/browser": "^7.0.0",
    "@capacitor/camera": "^7.0.0",
    "@capacitor/core": "^7.4.5",
    "@capacitor/device": "^7.0.0",
    "@capacitor/filesystem": "^7.0.0",
    "@capacitor/haptics": "^7.0.0",
    "@capacitor/ios": "^7.4.4",
    "@capacitor/keyboard": "^7.0.0",
    "@capacitor/preferences": "^7.0.0",
    "@capacitor/push-notifications": "^7.0.0",
    "@capacitor/screen-orientation": "^7.0.0",
    "@capacitor/status-bar": "^7.0.0",
    "@cloudinary/ng": "^2.0.2",
    "@cloudinary/url-gen": "^1.19.0",
    "@ebarooni/capacitor-calendar": "^7.1.0",
    "@fortawesome/angular-fontawesome": "^0.10.1",
    "@fortawesome/fontawesome-svg-core": "^1.2.36",
    "@fortawesome/free-brands-svg-icons": "^5.15.4",
    "@fortawesome/free-regular-svg-icons": "^5.15.4",
    "@fortawesome/free-solid-svg-icons": "^5.15.4",
    "@ionic/angular": "^8.7.6",
    "@ionic/pwa-elements": "^3.1.1",
    "@ionic/storage": "^4.0.0",
    "@ionic/storage-angular": "^4.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@popperjs/core": "^2.11.8",
    "@trapezedev/configure": "^7.0.10",
    "angularx-qrcode": "^20.0.0",
    "card-validator": "^8.1.1",
    "cloudinary-core": "^2.13.1",
    "cordova-plugin-file-opener2": "^4.0.0",
    "date-fns": "^4.1.0",
    "file-saver": "^2.0.5",
    "jetify": "^1.0.2",
    "jsbarcode": "^3.12.1",
    "jwt-decode": "^3.1.2",
    "moment": "^2.29.1",
    "moment-timezone": "^0.5.33",
    "ng-block-ui": "^3.0.2",
    "ngx-barcode6": "^1.20.1",
    "ngx-mask": "^20.0.3",
    "ngx-pagination": "^6.0.3",
    "rxjs": "^7.5.0",
    "scriptjs": "^2.5.9",
    "swiper": "^11.1.4",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.5",
    "@angular/cli": "^20.3.5",
    "@angular/compiler-cli": "^20.3.4",
    "@angular/language-service": "^20.3.4",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^7.4.5",
    "@ionic/angular-toolkit": "^9.0.0",
    "@playwright/test": "^1.40.0",
    "@types/jasmine": "~4.3.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/node": "^12.11.1",
    "@typescript-eslint/eslint-plugin": "5.3.0",
    "@typescript-eslint/parser": "5.3.0",
    "eslint": "^7.26.0",
    "eslint-plugin-import": "2.22.1",
    "eslint-plugin-jsdoc": "30.7.6",
    "eslint-plugin-prefer-arrow": "1.2.2",
    "jasmine-core": "~4.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "jetifier": "^2.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "ts-node": "~8.3.0",
    "typescript": "^5.8.3"
  },
  "description": "Fit Pro Tracker",
  "overrides": {
    "form-data": "4.0.4",
    "xml2js": "0.6.2",
    "tough-cookie": "6.0.0",
    "tmp": "0.2.5",
    "semver": "7.7.3"
  }
}
